function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.9989658,7.87786488 C15.0664019,11.7412738 11.9856077,14.9315295 8.12218712,14.9989658 C4.25877823,15.0664019 1.06852246,11.9856077 1.0010864,8.12219878 C0.933650148,4.25877823 4.01444434,1.06852246 7.87785322,1.0010864 C11.7412738,0.933650148 14.9315295,4.01444434 14.9989658,7.87786488 Z M11.5661612,5 L7.24210006,9.32298023 L5.08088017,7.16176033 L4,8.2426405 L7.2426405,11.485281 L12.6470413,6.08088017 L11.5661612,5 Z",
  id: "Combined-Shape"
}));
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.55c82b4b409152121fbf471360f43b3e.svg";
export { ForwardRef as ReactComponent };